// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"2e355fe7","290":"34ae144d","358":"00487506","428":"5cecd08e","672":"55f060f9"}[chunkId] + ".chunk.js";
};